// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cdf5c676","453":"92f0996e","732":"256e1c37","977":"8011cf54"}[chunkId] + ".chunk.js";
};